export default __webpack_public_path__ + "29c25cf28dfe3303e48fb69af1ad1180.png";